<template>
  <div class="container clearfix">
    <div class="shadow-wrapper padding-m mb-s">
      <h3 class="mb-s">繳費資料</h3>
      <OddVerThTable 
          :rows="paymentInfo"
          :style="{marginBottom: '10px'}"
        />
      <p class="tips-primary">依目前法令規定規定網路投保之「被保險人」及「要保人」及繳付保費的持卡人需同一人。</p>
    </div>
    <div class="shadow-wrapper padding-m mb-s">
      <h3 class="mb-s">繳費方式</h3>
       <OddVerThTable 
          :rows="creditCardInfo"
          :style="{marginBottom: '20px'}"
        />
      <CreditCardForm ref="creditCardForm" />
    </div>
    <Button
      class="pull-right btn-m btn-primary"
      @click="next"
      v-text="'下一步'"
    />
  </div>
</template>

<script>
  import { mapState,mapGetters } from 'vuex';
  import { Button,Spin } from 'iview';
  import format from 'date-fns/format';

  import CreditCardForm from '@/components/forms/CreditCardForm';
  import OddVerThTable from '@/components/tables/OddVerThTable';
  import { CHECKOUT_PAYMENT_ACTION } from '@/store/modules/checkout/constants';
  export default {
    components: { CreditCardForm, Button, OddVerThTable,Spin },
    props: {
      insuType: {
        type: String,
        default: 'car'
      },
    },
    computed: {
      ...mapGetters(['userInfo']),
      ...mapState({
        insuInfos: ({ checkout }) => (checkout.insuInfos),
        quotationPrice:  ({ checkout }) => (checkout.quotes.total),
        basketNum: ({ checkout }) => (checkout.quotes.basketNum),
        tranNum: ({ checkout }) => (checkout.quotes.tranNum),
        quotationNum: ({ checkout }) => (checkout.quotes.quotationNum),
        checkout: ({ checkout }) => (checkout),
        userIdentityNo: ({ user }) => user.profile.identityNo
      }),
      insuIds() {
        const result = [...this.insuInfos];
        return result.map(info => info.insuId);
      },
      checkoutInfo() {
        const { insuType, checkout } = this;
        switch (insuType) {
          case 'car':
            return checkout.infoOfCar;
            break;
          case 'motor':
            return checkout.infoOfMotor;
            break;
          case 'travel':
            return checkout.infoOfTravel;
            break;
           case 'accident':
            return checkout.infoOfAccident;
            break;  
            case 'pet':
            return checkout.infoOfPet;
            break;  
            case 'vaccine':
            return checkout.infoOfVaccine;
            break; 
        }
      },
      creditCardInfo() {
        const { userInfo: {fullName}, userIdentityNo } = this;
        const data = [
            { title: '持卡人姓名', content: fullName },
            { title: '持卡人身分證字號', content: userIdentityNo },
          ]   
        return data;
      },
      paymentInfo() { 
        const { quotationPrice } = this;
        const data = [
            { title: '繳費金額', content:  `新台幣 ${quotationPrice} 元整`},
            { title: '繳費日期', content: format(new Date(), 'YYYY 年 MM 月 DD 日') },
          ]   
        return data;
      }
    },
    methods: {
      async next() { 
            
        const {
          $store,
          insuIds,
          basketNum,
          tranNum,
          quotationNum,
          quotationPrice,
          insuType,
          checkoutInfo
        } = this;
        const creditCard = await this.$refs.creditCardForm.getPayload();
        if(creditCard) {
          Spin.show(); 
          const payload = {
            insuIds,
            basketNum,
            tranNum,
            quotationNum,
            quotationPrice,
            creditCard,
            checkoutInfo
          }
          const paymentStatus = await $store.dispatch(CHECKOUT_PAYMENT_ACTION,{insuType,payload});
          Spin.hide(); 
          if(paymentStatus) {
            this.$router.push({ 
              name: 'checkoutSucc',
              params: { 
                current: 4,
              } 
            });
          }
        }
      }
    }
  }
</script>
